import { CALL_API } from '../middleware/api'

export const CALENDAR_REQUEST = 'CALENDAR_REQUEST'
export const CALENDAR_SUCCESS = 'CALENDAR_SUCCESS'
export const CALENDAR_FAILURE = 'CALENDAR_FAILURE'

export function fetchCalendarByOperator(id, type, zone) {
  // Use URLSearchParams to build the query string
  const searchParams = new URLSearchParams();

  // Append type if provided
  if (type !== undefined) {
    searchParams.append('type', type);
  }

  // Append zone if provided
  if (zone !== undefined) {
    searchParams.append('zone', zone);
  }

  // Construct the final endpoint with the query string
  const params = searchParams.toString();
  const endpoint = `calendars/operator/${id}${params ? '?' + params : ''}`;

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint,  // Use the dynamically generated endpoint
      authenticated: true,
      types: [CALENDAR_REQUEST, CALENDAR_SUCCESS, CALENDAR_FAILURE]
    }
  }
}

export function fetchCalendarByContract(id, type, zone) {
  // Use URLSearchParams to build the query string
  const searchParams = new URLSearchParams();

  // Append type if provided
  if (type !== undefined) {
    searchParams.append('type', type);
  }

  // Append zone if provided
  if (zone !== undefined) {
    searchParams.append('zone', zone);
  }

  // Construct the final endpoint with the query string
  const params = searchParams.toString();
  const endpoint = `calendars/contract/${id}${params ? '?' + params : ''}`;

  return {
    [CALL_API]: {
      method: 'GET',
      endpoint,  // Use the dynamically generated endpoint
      authenticated: true,
      types: [CALENDAR_REQUEST, CALENDAR_SUCCESS, CALENDAR_FAILURE]
    }
  }
}